import camelCase from 'lodash/camelCase';
import XLSX from 'xlsx';
import loadFile from '../file-loader'; // There doesn't seem to be an easy way to just get a row.
// So we iterate with XLSX's decoding tools

const formatHeaders = ws => {
  const range = XLSX.utils.decode_range(ws['!ref']);
  const headers = [];
  let C = range.s.c;

  for (; C <= range.e.c; C += 1) {
    const addr = XLSX.utils.encode_cell({
      r: range.s.r,
      c: C
    });
    const cell = ws[addr];
    if (cell) headers.push(camelCase(cell.v));
  }

  return headers;
};

const parseXLSFile = file => loadFile(file).then(fileResult => {
  const data = new Uint8Array(fileResult);
  const wb = XLSX.read(data, {
    type: 'array'
  });
  /* Get first worksheet */

  const ws = wb.Sheets[wb.SheetNames[0]];
  const headers = formatHeaders(ws);
  /* Convert array of arrays */

  const jsonArray = XLSX.utils.sheet_to_json(ws, {
    header: headers,
    range: 1
  });
  return jsonArray;
});

export default parseXLSFile;